export const hasDetails = (e: unknown): e is { details: string[] } =>
  e !== null &&
  typeof e === 'object' &&
  'details' in e &&
  Array.isArray((e as { details: unknown }).details);
